import { useMulticityFiltersAggregate } from '@/src/hooks/srp/multicity/useMulticityFiltersAggregate'
import { useClearFilters } from '@/src/hooks/srp/clearFilters'
import useStopFilterManager from '@/src/hooks/srp/stopFilterManager'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { TranslationFunction } from '@/src/types/translations'
import { Box } from '@mui/material'
import React from 'react'
import FloatingFilterBar from './floatingFilterBar'

interface SrpFilterAndSortTabBarProps {
    onFilterClick?: () => void
    onSortClick?: () => void
    t: TranslationFunction<'common'>
}

const SrpFilterAndSortTabBar: React.FC<SrpFilterAndSortTabBarProps> = ({ onFilterClick, onSortClick, t }) => {
    const { isMulticity } = useSearchResults()
    const { nonStopToggle, nonStopChecked, isNonstopFlightAvailable: showNonstopToggle } = useStopFilterManager(0)
    const { numberOfFiltersApplied: owRtFiltersCount } = useClearFilters(0)
    const { numberOfFiltersApplied: multicityFiltersCount } = useMulticityFiltersAggregate()

    const filtersCount = isMulticity ? multicityFiltersCount : owRtFiltersCount || 0

    return (
        <Box sx={{ width: '100%' }}>
            <FloatingFilterBar
                filtersCount={filtersCount}
                nonStopEnabled={showNonstopToggle}
                nonStopChecked={!!nonStopChecked}
                onFilterClick={onFilterClick}
                onSortClick={onSortClick}
                onNonStopClick={nonStopToggle}
                filterLabel={t('filter')}
                sortLabel={t('sort')}
                nonStopLabel={t('direct')}
            />
        </Box>
    )
}

export default SrpFilterAndSortTabBar
